import { ApplicationRef, Injectable, inject, signal } from '@angular/core';

// A mesma chave é lida pelo script do index.html, que aplica o tema antes de a aplicação carregar
const THEME_KEY = 'theme';
// Classe configurada como darkModeSelector do PrimeNG (app.config.ts) e como variante "dark" do Tailwind
const DARK_CLASS = 'app-dark';
const TRANSITION_CLASS = 'theme-transition';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private appRef = inject(ApplicationRef);
  private root = document.documentElement;

  private readonly dark = signal(this.root.classList.contains(DARK_CLASS));
  readonly isDark = this.dark.asReadonly();

  toggle() {
    const dark = !this.dark();
    localStorage.setItem(THEME_KEY, dark ? 'dark' : 'light');

    const apply = () => {
      this.root.classList.toggle(DARK_CLASS, dark);
      this.dark.set(dark);
      // Atualiza já o ícone do botão, para entrar na mesma "foto" do novo tema
      this.appRef.tick();
    };

    // Sem suporte à View Transitions API (ou com animações reduzidas no sistema), a troca é imediata
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!document.startViewTransition || reducedMotion) {
      apply();
      return;
    }

    // A classe liga a animação de revelação definida em styles.css
    this.root.classList.add(TRANSITION_CLASS);
    document.startViewTransition(apply).finished.finally(() => this.root.classList.remove(TRANSITION_CLASS));
  }
}
